import React from "react";
import "./FeatureSection.css";

const features = [
  {
    id: 1,
    img: "./assets/icon-1.png",
    title: "Advanced Scar Healing",
    hoveringText:
      "Promote faster, more effective scar healing by hydrating the skin and reducing collagen buildup.",
  },
  {
    id: 2,
    img: "./assets/icon-2.png",
    title: "Regulates Collagen Production",
    hoveringText:
      "The sheets reduce excess collagen, which causes abnormal scar formation, resulting in smoother, less noticeable scars.",
  },
  {
    id: 3,
    img: "./assets/icon-3.png",
    title: "Reduces Trans-epidermal Water Loss (TEWL)",

    hoveringText:
      "The sheets prevent dehydration of the outermost layer of the skin, which is crucial for effective healing.",
  },
  {
    id: 4,
    img: "./assets/icon-4.png",
    title: "Versatile Range of Sizes",
    hoveringText:
      "The sheets prevent dehydration of the outermost layer of the skin, which is crucial for effective healing.",
  },
  {
    id: 5,
    img: "./assets/icon-5.png",
    title: "Hypoallergenic",
    hoveringText:
      "No matter the size or shape of your scar, we have you covered—fromsurgical incisions to acne scars.",
  },
  {
    id: 6,
    img: "./assets/icon-6.png",
    title: "Lightweight and Comfortable",
    hoveringText:
      "Designed for easy and discreet wear under clothing, making it convenient for everyday use.",
  },
  {
    id: 7,
    img: "./assets/icon-7.png",
    title: "Gentle on Skin",
    hoveringText:
      "Designed for easy and gentle removal, it minimizes skin stripping and protects the fragile, healing skin beneath.",
  },
];

const FeatureSection = () => {
  return (
    <section className="feature-section">
      <h2>RemeCure: Effective Scar Care for All Types of Scars</h2>

      {/* First row: 4 cards */}
      <div className="features-container">
        {features.slice(0, 4).map((feature) => (
          <div key={feature.id} className="feature-card">
            <div className="hover-overlay">
              <p>{feature.hoveringText}</p>
            </div>
            <div className="card-content">
              <div className="icon-wrapper">
                <img src={feature.img} alt={feature.title} />
              </div>
              <h6>{feature.title}</h6>
            </div>
          </div>
        ))}
      </div>

      {/* Second row: 3 cards (centered) */}
      <div className="centered-features">
        {features.slice(4).map((feature) => (
          <div key={feature.id} className="feature-card">
            <div className="hover-overlay">
              <p>{feature.hoveringText}</p>
            </div>
            <div className="card-content">
              <div className="icon-wrapper">
                <img src={feature.img} alt={feature.title} />
              </div>
              <h6>{feature.title}</h6>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureSection;
